"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncPipeline = exports.usePipeline = exports.createPipeline = exports.getMiddleware = exports.isPipeline = exports.assertContext = exports.isContainer = exports.isContext = exports.assertContainer = exports.runWithContainer = exports.useContainer = exports.createContainer = exports.createContext = void 0;
const context_1 = require("./context");
Object.defineProperty(exports, "createContext", { enumerable: true, get: function () { return context_1.createContext; } });
Object.defineProperty(exports, "createContainer", { enumerable: true, get: function () { return context_1.createContainer; } });
Object.defineProperty(exports, "assertContainer", { enumerable: true, get: function () { return context_1.assertContainer; } });
Object.defineProperty(exports, "isContext", { enumerable: true, get: function () { return context_1.isContext; } });
Object.defineProperty(exports, "isContainer", { enumerable: true, get: function () { return context_1.isContainer; } });
Object.defineProperty(exports, "assertContext", { enumerable: true, get: function () { return context_1.assertContext; } });
Object.defineProperty(exports, "useContainer", { enumerable: true, get: function () { return context_1.useContainer; } });
Object.defineProperty(exports, "runWithContainer", { enumerable: true, get: function () { return context_1.runWithContainer; } });
const counter_1 = require("./counter");
const isPipeline = (input) => {
    return !!(input && input[PipelineSymbol]);
};
exports.isPipeline = isPipeline;
const PipelineSymbol = Symbol('pipeline');
const getMiddleware = (input) => {
    if (typeof input === 'function') {
        return input;
    }
    else if (input && typeof input.middleware === 'function') {
        return input.middleware;
    }
    throw new Error(`${input} is not a Middleware or { middleware: Middleware }`);
};
exports.getMiddleware = getMiddleware;
const createPipeline = (options) => {
    const config = Object.assign({}, options);
    const middlewares = [];
    const use = (...inputs) => {
        middlewares.push(...inputs.map(exports.getMiddleware));
        return pipeline;
    };
    const createCurrentCounter = (hooks, onLast, onLastWithContext) => {
        return (0, counter_1.createCounter)((index, input, next) => {
            if (index >= middlewares.length) {
                if (onLast) {
                    if (onLastWithContext) {
                        return (0, context_1.runHooks)(() => onLast(input), hooks);
                    }
                    return onLast(input);
                }
                throw new Error(`Expect returning a value, but all middlewares just calling next()`);
            }
            const middleware = middlewares[index];
            const result = (0, context_1.runHooks)(() => middleware(input, next), hooks);
            return result;
        });
    };
    const currentContainer = (0, context_1.createContainer)(config.contexts);
    const currentHooks = (0, context_1.fromContainer)(currentContainer);
    const currentCounter = createCurrentCounter(currentHooks);
    const run = (input, options) => {
        var _a;
        const container = (_a = options === null || options === void 0 ? void 0 : options.container) !== null && _a !== void 0 ? _a : currentContainer;
        const hooks = container === currentContainer ? currentHooks : (0, context_1.fromContainer)(container);
        let counter = container === currentContainer ? currentCounter : createCurrentCounter(hooks);
        if (options === null || options === void 0 ? void 0 : options.onLast) {
            const onLastWithContext = typeof options.onLastWithContext === 'boolean' ? options.onLastWithContext : true;
            counter = createCurrentCounter(hooks, options.onLast, onLastWithContext);
        }
        const result = counter.start(input);
        return result;
    };
    const middleware = (input, next) => {
        const container = (0, context_1.useContainer)();
        return run(input, {
            container,
            onLast: next,
        });
    };
    const pipeline = {
        [PipelineSymbol]: true,
        use,
        run,
        middleware,
    };
    return pipeline;
};
exports.createPipeline = createPipeline;
const usePipeline = (pipeline) => {
    const container = (0, context_1.useContainer)();
    const runPipeline = (input, options) => {
        return pipeline.run(input, Object.assign(Object.assign({}, options), { container }));
    };
    return runPipeline;
};
exports.usePipeline = usePipeline;
const createAsyncPipeline = (options) => {
    const pipeline = (0, exports.createPipeline)(options);
    const useLazy = (thunk) => {
        let middleware = null;
        let promise = null;
        pipeline.use((input, next) => {
            if (middleware)
                return next(input);
            if (!promise) {
                promise = Promise.resolve(thunk()).then((result) => {
                    middleware = (0, exports.getMiddleware)(result);
                });
            }
            return promise.then(() => next(input));
        });
        pipeline.use((input, next) => {
            if (!middleware)
                throw new Error(`pipeline.useLazy failed to load middleware`);
            return middleware(input, next);
        });
        return asyncPipeline;
    };
    const asyncPipeline = Object.assign(Object.assign({}, pipeline), { useLazy });
    return asyncPipeline;
};
exports.createAsyncPipeline = createAsyncPipeline;
//# sourceMappingURL=pipeline.js.map